import React from 'react'
import moment from 'moment'

Number.prototype.formatMoney = function (c, d, t) {
  var n = this,
    c = isNaN(c = Math.abs(c)) ? 2 : c,
    d = d == undefined ? "." : d,
    t = t == undefined ? "," : t,
    s = n < 0 ? "-" : "",
    i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "",
    j = (j = i.length) > 3 ? j % 3 : 0;
  return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
}

function formatValue(row, key) {
  // row: array of obj
  // key: obj key
  const val = row[key]
  if (isNaN(val) || val === '')
    return val
  return parseInt(val).formatMoney(2)
}

const momentHelper = {
  getMonth() {
    const monthNumber = new Date().getMonth() + 1
    return ('0000' + monthNumber).slice(-2)
  },

  getMonthText(monthNumber) {
    return monthNumber !== '00' ? moment(monthNumber).format('MMMM') : 'ทั้งปี'
  },

  getYear() {
    return (new Date().getFullYear() * 1 + 543)
  },

  getThaiYear(date) {
    // date format: DD / MM / YYYY
    if (date.lastIndexOf("/") > date.length - 5) return ""
    return date.slice(date.lastIndexOf("/") + 1) * 1 + 543 + ""
  },

  getFullDate(date) {
    // moment.locale('th')
    const dayMonth = date.slice(0, date.lastIndexOf("/"))
    return moment(dayMonth).format('Do MMMM') + " " + this.getThaiYear(date)
  }
}

const tableHelper = {
  formatValue(row, key) {
    // row: array of obj
    // key: obj key
    const val = row[key]
    // if (key.indexOf('Date') !== -1 && val.lastIndexOf("/") !== -1)
    //   return val.slice(0, val.lastIndexOf("/"))
    //     + "/"
    //     + momentHelper.getThaiYear(val).slice(2)
    if (isNaN(val) || val === '')
      return val
    if (typeof val === 'object')
      return val
    return parseInt(val).formatMoney(2)
  },

  renderHeader(titles) {
    const ths = titles.map((title, i) => (
      <th key={i} className='text-center'>{title}</th>
    ))

    return (
      <thead>
        <tr>
          {ths}
        </tr>
      </thead>
    )
  },

  renderRowHeader(item,i){
    if(item.width !==undefined){
      return (<th key={i} className='text-center' style={{width:item.width}}>{item.title}</th>)
    }else{
      return (<th key={i} className='text-center' >{item.title}</th>)
    }
  },

  renderHeaderCustom(headers) {
    const ths = headers.map((item, i) => (
      this.renderRowHeader(item,i)
    ))

    return (
      <thead>
        <tr>
          {ths}
        </tr>
      </thead>
    )
  },

  renderRows(rows, excludedColumns) {
    return rows.map((row, index) => {
      // create an array of <td>
      const tds = Object.keys(row).map((key, kid) => {
        if (excludedColumns !== undefined && excludedColumns.includes(key))
          return

        const formattedValue = this.formatValue(row, key)
        const tdClass = isNaN(row[key]) ? "text-left" : "text-right"
        return <td className={tdClass} key={kid + 1}>{formattedValue}</td>
      })

      return <tr key={index}>{tds}</tr>
    })
  },

  renderRowsWithIds(rows, excludedColumns) {
    return rows.map((row, index) => {
      // create an array of <td>
      const tds = Object.keys(row).map((key, kid) => {
        if (excludedColumns.includes(key)) return

        const formattedValue = this.formatValue(row, key)
        const tdClass = isNaN(row[key]) ? "text-left" : "text-right"
        return <td className={tdClass} key={kid + 1}>{formattedValue}</td>
      })

      // add id column to array of <td>
      const tdWithIds = [<td key={0} className="text-center" >{index + 1}</td>].concat(tds)
      return <tr key={index}>{tdWithIds}</tr>
    })
  },

  renderRowsCustom(rows,excludedColumns,onRenderColumn,onRowClick){
    
    return rows.map((row, index) => {
      // create an array of <td>
      const tds = Object.keys(row).map((key, kid) => {
        if (excludedColumns !== undefined && excludedColumns.includes(key))
          return

        const formattedValue = this.formatValue(row, key)
        const tdClass = isNaN(row[key]) ? "text-left" : "text-right"
        return <td className={tdClass} key={kid + 1}>{onRenderColumn(formattedValue,kid)}</td>
      })

      return <tr key={index} onClick={this.onRowClick.bind(this,onRowClick,index)}>{tds}</tr>
    })
  },

}

export { momentHelper, tableHelper }



// WEBPACK FOOTER //
// ./src/view/hr/report/helpers.js